import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowForward, SingpassButton } from "../../assets/svg/AllSvg";
import { Logo } from "../../assets/image";
import { SingpassLogo } from "../../assets";

const Singpass = () => {
  const { id, email } = useParams();
  const navigate = useNavigate();

  const singpassBaseURL = process.env.REACT_APP_SINGPASS_URL;

  useEffect(() => {
    if (email && id) {
      sessionStorage.setItem("email", email);
      sessionStorage.setItem("id", id);
    }
  }, [email, id]);

  const [QRCodeURL, setQRCodeURL] = useState("");
  const [urlError, setUrlError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function initSingpassLogin() {
      try {
        setIsLoading(true);
        setUrlError(null);

        function base64urlencode(buffer) {
          return btoa(String.fromCharCode(...new Uint8Array(buffer)))
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");
        }

        function generateCodeVerifier(length = 128) {
          const array = new Uint8Array(length);
          window.crypto.getRandomValues(array);
          return Array.from(array)
            .map((b) => b.toString(36))
            .join("")
            .slice(0, length);
        }

        async function generateCodeChallenge(code_verifier) {
          const encoder = new TextEncoder();
          const data = encoder.encode(code_verifier);
          const digest = await window.crypto.subtle.digest("SHA-256", data);
          return base64urlencode(digest);
        }

        if (!singpassBaseURL) {
          throw new Error("Singpass base URL is not configured");
        }

        const authurl = `${singpassBaseURL}/auth?`;
        const scope = "openid uinfin name email";
        const response_type = "code";
        const client_id = "2BAGci8ejgv5tYD71Xm01m2gSaGLZf7y";
        const redirect_uri = encodeURIComponent(
          "https://customer.eibiz.superfastech.com/callback"
        );

        const code_verifier = generateCodeVerifier();
        const code_challenge = await generateCodeChallenge(code_verifier);

        sessionStorage.setItem("singpass_code_verifier", code_verifier);

        const nonce = crypto.randomUUID();
        const state = crypto.randomUUID();

        const url =
          `${authurl}` +
          `scope=${scope}` +
          `&state=${state}` +
          `&response_type=${response_type}` +
          `&redirect_uri=${redirect_uri}` +
          `&client_id=${client_id}` +
          `&nonce=${nonce}` +
          `&code_challenge=${code_challenge}` +
          `&code_challenge_method=S256`;

        setQRCodeURL(url);
      } catch (error) {
        console.error("Error initializing Singpass login:", error);
        setUrlError(
          error.message || "Failed to initialize Singpass authentication"
        );
      } finally {
        setIsLoading(false);
      }
    }

    initSingpassLogin();
  }, [singpassBaseURL]);
  return (
    <div>
      <div className="main">
        <div className="main-logo ">
          <img src={Logo} alt="logo" className="w-full h-full object-cover" />
        </div>
        <div className="center-h">
          <section className="w-full">
            <div className="max-w-2xl w-full mx-auto space-y-7">
              <div className="relative w-[30rem] mx-auto h-fit">
                <img
                  src={SingpassLogo}
                  alt="welcome"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="text-center font-ebGaramond space-y-4">
                <h1 className="text-3xl">Let’s get you started!</h1>
                <p className="text-xl">
                  Faster form filling with Singpass. Singpass enables you to
                  retrieve your personal data from participating Government
                  agencies. With your consent, we can auto-fill this form,
                  making your application more convenient.
                </p>
              </div>

              {/* <button
                type="button"
                className="btn !bg-[#F4333D] border-none max-w-xs mx-auto !text-lg font-semibold"
                onClick={() => {
                  window.location.href = QRCodeURL;
                }}
              >
                Retrieve Myinfo with Singpass
              </button> */}
              <div className="flex justify-center">
                {isLoading ? (
                  <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-red-600 mr-3"></div>
                    <span className="text-gray-600">
                      Preparing Singpass authentication...
                    </span>
                  </div>
                ) : urlError ? (
                  <div className="text-center">
                    <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
                      <p className="text-red-600 text-sm">{urlError}</p>
                    </div>
                    <button
                      type="button"
                      className="bg-gray-600 hover:bg-gray-700 text-white px-6 py-2 rounded-lg font-semibold"
                      onClick={() => window.location.reload()}
                    >
                      Retry
                    </button>
                  </div>
                ) : (
                  <button
                    type="button"
                    onClick={() => {
                      if (QRCodeURL) {
                        window.location.href = QRCodeURL;
                      }
                    }}
                    disabled={!QRCodeURL}
                  >
                    <SingpassButton />
                  </button>
                )}
              </div>

              <div className="flex justify-center">
                <button
                  type="submit"
                  className="flex items-center text-theme space-x-2"
                  onClick={() =>
                    navigate(`/sign-up`, {
                      state: { fromSingpass: true },
                    })
                  }
                >
                  <span className="text-lg uppercase">
                    For foreigner proceed on here
                  </span>
                  <ArrowForward className="fill-theme" fill="" />
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Singpass;
